module.exports = __webpack_public_path__ + "static/media/contacts_en.3501452f.png";